import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { VisaLogo, MastercardLogo, AzulBadge, VerifiedByVisa, MastercardIDCheck } from './PaymentBadges';

// Footer único del sitio (se renderiza una sola vez desde App).
// Consolida marca + columnas + medios de pago + barra inferior, de forma compacta.
export default function Footer() {
  const { t } = useTranslation();
  const linkCls = "hover:text-white transition-colors";
  return (
    <footer className="bg-[#111827] text-white">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-8">

        {/* Columnas */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-7">
          {/* Marca */}
          <div className="col-span-2 md:col-span-1">
            <img src={`${process.env.PUBLIC_URL}/images/logo-light.png`} alt="RedMobility" className="h-9 max-w-none object-contain mb-3" />
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">{t('homepage.footerTagline')}</p>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-semibold mb-3 text-sm">{t('homepage.company')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/sobre-nosotros" className={linkCls}>{t('homepage.aboutLink')}</Link></li>
              <li><Link to="/contacto" className={linkCls}>{t('homepage.contactLink')}</Link></li>
              <li><Link to="/blog" className={linkCls}>{t('homepage.blogLink')}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3 text-sm">{t('homepage.legal')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/terminos" className={linkCls}>{t('homepage.termsLink2')}</Link></li>
              <li><Link to="/privacidad" className={linkCls}>{t('homepage.privacyLink2')}</Link></li>
              <li><Link to="/cancelacion" className={linkCls}>{t('homepage.cancellationLink')}</Link></li>
              <li><Link to="/seguridad" className={linkCls}>{t('footer.security', 'Seguridad')}</Link></li>
              <li><Link to="/entrega" className={linkCls}>{t('footer.delivery', 'Entrega')}</Link></li>
            </ul>
          </div>

          {/* Soporte */}
          <div>
            <h4 className="font-semibold mb-3 text-sm">{t('homepage.support')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/contacto" className={linkCls}>{t('homepage.helpCenter')}</Link></li>
              <li><a href="https://wa.me/18095550100" target="_blank" rel="noopener noreferrer" className={linkCls}>WhatsApp: +1-809-555-0100</a></li>
              <li><a href="mailto:info@redmobility.com" className={linkCls}>info@redmobility.com</a></li>
            </ul>
          </div>
        </div>

        {/* Medios de pago */}
        <div className="flex flex-wrap items-center gap-2 mt-7">
          <VisaLogo className="h-6" />
          <MastercardLogo className="h-6" />
          <AzulBadge className="h-6" />
          <span className="w-px h-5 bg-gray-700 mx-1" aria-hidden="true" />
          <VerifiedByVisa className="h-6" />
          <MastercardIDCheck className="h-6" />
        </div>

        {/* Barra inferior */}
        <div className="border-t border-gray-800 mt-6 pt-5 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-gray-500">
          <p>
            {t('homepage.rightsReserved')}{' '}
            <a href="https://redmobility.net" target="_blank" rel="noopener noreferrer" className="text-[#36C0C7] hover:underline">RedMobility.net</a>
          </p>
          <p className="text-gray-600">
            {t('homepage.photoCredits', 'Fotografías de categorías:')}{' '}
            <a href="https://commons.wikimedia.org" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-400">Wikimedia Commons</a>{' '}(CC BY / CC BY-SA)
          </p>
        </div>
      </div>
    </footer>
  );
}
